/* eslint-disable @typescript-eslint/no-explicit-any */
import PhIcon from '@mercadoni/sinister/dist/cjs/PhIcon'
import { Menu } from 'antd'
import Link from './Link'
import styles from './MenuDropdown.module.css'
import Text from './Text'

const MenuDropdown = ({ items = [] }: { items: any[] }) => {
  const getMenuItem = (item: any) => {
    const { name, link, key, children } = item

    if (children?.length) {
      const parsedChildren = children.map((child: any) => getMenuItem(child))
      return {
        key,
        label: <Text text={name} />,
        children: parsedChildren,
      }
    }

    return {
      key,
      label: <Link text={name} {...link} />,
    }
  }

  const menuItems = items.map((item) => getMenuItem(item))

  return (
    <Menu
      className={styles.menuDropdown}
      items={menuItems}
      expandIcon={<PhIcon className="ph-caret-right" />}
    />
  )
}

export default MenuDropdown
